var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"stacked icons ml-1",class:_vm.stateColorClass},[_c('i',{staticClass:"circle icon m-auto",attrs:{"id":"circle"}}),_c('i',{staticClass:"circle outline icon",attrs:{"id":"outline"}})])}
var staticRenderFns = []

export { render, staticRenderFns }